module.exports = __webpack_public_path__ + "img/0info_icon.84dd16a7.svg";